var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgC(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 408.32 459.48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 324.21,
    y1: -82.02,
    x2: 453.5,
    y2: 83.46,
    gradientTransform: "translate(10.3 244.09) scale(0.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3b009b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#390086"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 120.4,
    y1: 237.8,
    x2: 261.84,
    y2: 418.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#340084"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#290064"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -5993.67,
    y1: -7703.14,
    x2: 363.66,
    y2: 433.78,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a47ede"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9866d3"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "c-sharp-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2-2",
    "data-name": "Layer 1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M403.19,344.8a36.82,36.82,0,0,0,5.13-17.6V132.28A37,37,0,0,0,403,114.82L204.37,229.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.37,229.75l-4.61,2.67L5.32,344.93a38.67,38.67,0,0,0,12.36,12.88l168.8,97.45c9.72,5.62,25.64,5.62,35.36,0l168.8-97.45c.32-.21.62-.44.94-.66a40.16,40.16,0,0,0,11.61-12.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M400.93,111.71a41.16,41.16,0,0,0-10.29-10.05L221.84,4.21c-9.72-5.62-25.64-5.62-35.36,0L17.68,101.66C8,107.27,0,121.06,0,132.28V327.19a38.67,38.67,0,0,0,5.32,17.74L199.76,232.42l4.61-2.67L403,114.82Q402,113.23,400.93,111.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    className: "cls-4",
    d: "M68.06,229.74c-.8-132.9,177.21-191.58,254-68.1l-58.9,34.09c-35.56-58.81-123.85-37.78-127,34,1,66.17,87.73,96.9,127,34l58.9,34.08C254.38,415.27,71.47,373,68.06,229.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "sharp"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "292.57 191.16 303.79 191.16 296.12 265.19 284.69 265.19 292.57 191.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "316.6 191.16 327.81 191.16 320.15 265.19 308.72 265.19 316.6 191.16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 280,
    y: 208.73,
    width: 56.09,
    height: 10.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 276.86,
    y: 235.12,
    width: 56.09,
    height: 10.83
  }))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgC);
export default __webpack_public_path__ + "static/media/c#.c73a763f0c6f702e06722066d74082fe.svg";
export { ForwardRef as ReactComponent };